import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import BackButton from '@/src/vueComponent/BackButton.vue'

$(document).on('turbo:load turbo:render', () => {
  const customerShippingReportShow = document.querySelector('#customer-shipping-report-show')
  if (customerShippingReportShow && !customerShippingReportShow.__vue_app__) {
    createApp({ components: { BaseAlert, BackButton } }).mount(customerShippingReportShow)
  }
})
